module.exports = __webpack_public_path__ + "img/b4dc743.svg";